import * as React from 'react';
import {PaperProps, Typography} from "@mui/material";
import Paper from "@mui/material/Paper";
import moment from 'moment'
import CircularProgress from "@mui/material/CircularProgress";
import red from '@mui/material/colors/red';
import green from '@mui/material/colors/green';
import orange from '@mui/material/colors/orange';
import {styled} from "@mui/material/styles";

const WalkTimeMinutes: number = 12;
const MinutesPast: number = 5;

interface TrainResponse {
    journeys: Journey[];
}

interface Journey {
    type: string;
    legs: Leg[];
}

interface Destination {
    name: string;
}

interface Leg {
    arrivalTime: string;
    arrivalTimePlanned: string;
    departingTime: string;
    departingTimePlanned: string;
    stopSequence: StopSequence[];
    destination: Destination;
}

interface StopSequence {
    departingTimeEstimated: string;
    departingTimePlanned: string;
    name: string;

}




// interface StopEvent {
//     departureTimeEstimated: string;
//     departureTimePlanned: string;
//     isRealtimeControlled: boolean;
//     onwardLocations: OnwardLocation[];
//     location: Location;
// }

// interface Location {
//     name: string;
// }

// interface OnwardLocation {
//     arrivalTimeEstimated: string;
//     arrivalTimePlanned: string;
//     departureTimeEstimated: string;
//     departureTimePlanned: string;
//     name: string;
//     parent: OnwardLocationParent;
// }

// interface OnwardLocationParent {
//     id: string;
// }

const StyledPaperCanMake = styled(Paper)<PaperProps>(({ theme }) => ({
    backgroundColor: green[200],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    margin: '5px 0px',
}));

const StyledPaperNeedToLeave = styled(Paper)<PaperProps>(({ theme }) => ({
    backgroundColor: orange[200],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    margin: '5px 0px',
}));

const StyledPaperMissed = styled(Paper)<PaperProps>(({ theme }) => ({
    backgroundColor: red[200],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    margin: '5px 0px',
}));


type State = {
    isLoaded: boolean;
    time: string;
    response: TrainResponse | null;
    showNextStop: boolean;
};

export interface Props {
    showNextStop: boolean;
}

export default class TrainTimetable extends React.Component<Props, State> {
    state = {
        isLoaded: false,
        time: new Date().toISOString(),
        response: null,
        showNextStop: this.props.showNextStop
    };
    componentDidMount() {
        setInterval( () => {
            this.setState({
                ...this.state,
                time : new Date().toISOString()
            })
        },1000 * 10)

        fetch("https://f7oq1obpl8.execute-api.ap-southeast-2.amazonaws.com/default/TransportNSW")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        ...this.state,
                        isLoaded: true,
                        response: result
                    })
                },
                (error) => {
                    this.setState({
                        ...this.state,
                        isLoaded: true,
                        response: null
                    })
                }
            )
    }

    renderCards() {

        if (this.state.response == null || !this.state.response.journeys) {
            return null;
        }

        const allTrains = this.state.response.journeys
            .filter((j: Journey) => j.type === 'publicTransport')
            .map((j: Journey, index: number) => {
                return j.legs[0];
            })
            .filter((l: Leg) => moment(l.departingTimePlanned).add(-1 * WalkTimeMinutes + MinutesPast, 'minutes').isAfter(this.state.time))
            .map((l: Leg, index: number) => {
                const departingTimeMoment = moment(l.departingTimePlanned);
                const departureTime = departingTimeMoment.utc().local().format("hh:mm:ss a");
                const departingInMinutes = departingTimeMoment.diff(this.state.time, "minutes");
                const leaveHomeIn = (this.props.showNextStop ? "Leave " : "Leave ") + departingTimeMoment.add(-1 * WalkTimeMinutes, 'minutes').from(this.state.time);
                let destination = l.destination.name;
                let firstStop = "First stop: " + (l.stopSequence.length > 0 ? l.stopSequence[1].name : "");

                const content = (
                    <>
                        <Typography component="p">
                            Departure time {departureTime}
                        </Typography>
                        <Typography variant="h5" component="h5">
                            {leaveHomeIn}
                        </Typography>
                        <Typography component="p">
                            {destination}
                        </Typography>
                        <Typography component="p">
                            {firstStop}
                        </Typography>

                    </>
                )

                if (departingInMinutes <= 10) {
                    return (
                        <StyledPaperMissed elevation={1} key={index}>
                            {content}
                        </StyledPaperMissed>
                    )
                } else if (departingInMinutes <= 20) {
                    return (
                        <StyledPaperNeedToLeave elevation={1} key={index}>
                            {content}
                        </StyledPaperNeedToLeave>
                    )
                } else {
                    return (
                        <StyledPaperCanMake elevation={1} key={index}>
                            {content}
                        </StyledPaperCanMake>
                    )
                }
        });

        return allTrains;

    }

    render() {
        if (!this.state.isLoaded) {
            return <CircularProgress/>;
        }
        return (
            this.renderCards()
        );
    }
}